"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentTemplateSerializer = void 0;
var models_1 = require("../../models");
var constants_1 = require("../../constants");
var question_type_enum_1 = require("../../constants/question-type.enum");
var multiple_choice_question_model_1 = require("../../models/multiple-choice-question.model");
var answer_option_model_1 = require("../../models/answer-option.model");
/**
 * Serializes assessment templates
 *
 * @author javier.perez
 */
var AssessmentTemplateSerializer = /** @class */ (function () {
    function AssessmentTemplateSerializer() {
    }
    AssessmentTemplateSerializer.prototype.serialize = function (_a) {
        var _this = this;
        var id = _a.id, active = _a.active, externalId = _a.externalId, curriculum = _a.curriculum, grade = _a.grade, module = _a.module, topic = _a.topic, type = _a.type, assignmentType = _a.assignmentType, sequence = _a.sequence, subject = _a.subject, settings = _a.settings, title = _a.title, subtitle = _a.subtitle, ownerId = _a.ownerId, items = _a.items, dok = _a.dok, manualScoring = _a.manualScoring, status = _a.status, stimulus = _a.stimulus, lesson = _a.lesson, itemSet = _a.itemSet, createdAt = _a.createdAt, language = _a.language, sharedUserIds = _a.sharedUserIds, resourceItemIds = _a.resourceItemIds, noStudentSubmissionsFlow = _a.noStudentSubmissionsFlow;
        var owner = ownerId ? new models_1.User({ id: ownerId }) : undefined;
        return new models_1.AssessmentTemplate({
            id: id,
            curriculum: curriculum,
            active: active,
            type: type ? (0, constants_1.getAssessmentTypeFrom)(type) : undefined,
            externalId: externalId,
            title: title,
            subtitle: subtitle,
            settings: settings,
            owner: owner,
            dok: dok,
            grade: grade,
            module: module,
            topic: topic,
            sequence: sequence,
            subject: subject,
            manualScoring: manualScoring,
            status: status ? (0, constants_1.getAssessmentTemplateStatusFrom)(status) : undefined,
            items: items ? items.map(function (item) { return _this.serializeItem(item); }) : [],
            createdAt: createdAt,
            stimulus: stimulus,
            lesson: lesson,
            itemSet: itemSet,
            assignmentType: assignmentType ? (0, constants_1.getAssignmentTypeFrom)(assignmentType) : undefined,
            language: language,
            sharedUserIds: sharedUserIds,
            resourceItemIds: resourceItemIds,
            noStudentSubmissionsFlow: noStudentSubmissionsFlow,
        });
    };
    AssessmentTemplateSerializer.prototype.serializeItem = function (_a) {
        var _this = this;
        var externalId = _a.externalId, externalBankItemId = _a.externalBankItemId, title = _a.title, description = _a.description, dok = _a.dok, maxScore = _a.maxScore, questions = _a.questions, manualScoring = _a.manualScoring, type = _a.type, scoringType = _a.scoringType, foundational = _a.foundational, ratingRubricVariation = _a.ratingRubricVariation;
        return new models_1.Item({
            externalId: externalId,
            externalBankItemId: externalBankItemId,
            title: title,
            description: description,
            dok: dok,
            maxScore: maxScore,
            manualScoring: manualScoring,
            type: type,
            questions: questions
                ? questions.map(function (question) { return _this.serializeQuestion(question); })
                : [],
            scoringType: scoringType ? (0, constants_1.getScoringTypeFrom)(scoringType) : undefined,
            foundational: foundational,
            variation: ratingRubricVariation ? (0, constants_1.getVariationsFrom)(ratingRubricVariation) : undefined,
        });
    };
    AssessmentTemplateSerializer.prototype.serializeQuestion = function (_a) {
        var externalId = _a.externalId, description = _a.description, rubricReference = _a.rubricReference, type = _a.type, maxScore = _a.maxScore, definition = _a.definition, _b = _a.distractorRationale, distractorRationale = _b === void 0 ? null : _b, _c = _a.distractorRationaleResponseLevel, distractorRationaleResponseLevel = _c === void 0 ? [] : _c;
        return new models_1.Question({
            externalId: externalId,
            description: description,
            type: type,
            maxScore: maxScore,
            rubricReference: rubricReference,
            definition: type === question_type_enum_1.QuestionType.MultipleChoice && definition
                ? this.serializeDefinition(definition)
                : undefined,
            distractorRationale: distractorRationale,
            distractorRationaleResponseLevel: distractorRationaleResponseLevel,
        });
    };
    AssessmentTemplateSerializer.prototype.serializeDefinition = function (_a) {
        var _this = this;
        var options = _a.options, correctAnswer = _a.correctAnswer;
        return new multiple_choice_question_model_1.MultipleChoiceQuestion({
            options: options ? options.map(function (answer) { return _this.serializeAnswerOption(answer); }) : [],
            correctAnswer: correctAnswer,
        });
    };
    AssessmentTemplateSerializer.prototype.serializeAnswerOption = function (_a) {
        var label = _a.label, value = _a.value;
        return new answer_option_model_1.AnswerOption({
            label: label,
            value: value,
        });
    };
    return AssessmentTemplateSerializer;
}());
exports.AssessmentTemplateSerializer = AssessmentTemplateSerializer;
